import { Rocket, Code, Zap, ArrowLeft, Sparkles, Loader } from "lucide-react";

function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-[#d9ebff] relative overflow-hidden">
      {/* Animated background grid */}
      <div className="absolute inset-0 opacity-5">
        <div className="grid grid-cols-12 gap-4 h-full">
          {Array.from({ length: 144 }).map((_, i) => (
            <div
              key={i}
              className="border border-[#27ade3] animate-pulse"
              style={{ animationDelay: `${i * 0.1}s` }}
            />
          ))}
        </div>
      </div>

      {/* Floating geometric shapes */}
      <div className="absolute top-1/4 left-1/4 w-20 h-20 border-2 border-[#27ade3]/20 rotate-45 animate-spin slow"></div>
      <div className="absolute top-1/3 right-1/4 w-16 h-16 bg-[#27ade3]/10 rounded-full animate-bounce delay-500"></div>
      <div className="absolute bottom-1/4 left-1/3 w-12 h-12 bg-gradient-to-br from-[#27ade3]/20 to-[#1a325d]/20 rotate-12 animate-pulse delay-1000"></div>

      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4">
        {/* Header with animated icons */}
        <div className="flex items-center gap-6 mb-8">
          <div className="p-4 bg-gradient-to-br from-[#27ade3]/20 to-[#1a325d]/20 rounded-2xl backdrop-blur-sm border border-white/30 shadow-xl">
            <Rocket className="w-8 h-8 text-[#27ade3] animate-pulse" />
          </div>
          <div className="p-4 bg-gradient-to-br from-[#1a325d]/20 to-[#27ade3]/20 rounded-2xl backdrop-blur-sm border border-white/30 shadow-xl">
            <Code className="w-8 h-8 text-[#1a325d] animate-pulse delay-300" />
          </div>
          <div className="p-4 bg-gradient-to-br from-[#27ade3]/20 to-white/20 rounded-2xl backdrop-blur-sm border border-white/30 shadow-xl">
            <Zap className="w-8 h-8 text-[#27ade3] animate-pulse delay-700" />
          </div>
        </div>

        {/* Main text with staggered animation */}
        <div className="text-center space-y-6 mb-12">
          <div className="space-y-4">
            <h1 className="text-5xl md:text-6xl font-black text-[#0a2540] leading-tight">
              Under Development
            </h1>
            <div className="h-1 w-32 bg-gradient-to-r from-[#27ade3] to-[#1a325d] mx-auto rounded-full"></div>
          </div>
          
          
          <p className="text-lg text-[#0a2540]/60 max-w-lg mx-auto leading-relaxed">
            This page is currently under construction. Our developers are working around the clock to bring you an amazing experience.
          </p>
        </div>

        {/* Action buttons */}
        <div className="mt-12 flex flex-col sm:flex-row gap-4 items-center">
          <button
            onClick={() => window.history.back()}
            className="group px-8 py-4 bg-gradient-to-r from-[#27ade3] to-[#1a325d] text-white rounded-xl font-semibold shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 hover:scale-105 flex items-center gap-3 relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <ArrowLeft className="w-5 h-5 transition-transform group-hover:-translate-x-1 relative z-10" />
            <span className="relative z-10">Go Back</span>
          </button>
        </div>
      </div>

      {/* Bottom decorative wave */}
      <div className="absolute bottom-0 left-0 w-full">
        <svg className="w-full h-32 fill-[#d9ebff]/30" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25"></path>
          <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5"></path>
          <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"></path>
        </svg>
      </div>
    </div>
  );
}

export default NotFound;